// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

export async function getContactAuditEvents(key: string) {
  const url = `/v1/contact/${key}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'ContactAuditEvents',
    endpoint: url,
  });
}
